import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  CustomHttpErrorResponse,
  Error,
  LIST_SERVER_PAGINATION_INITIAL_STATE,
  ListServerPaginationStateModel,
  NotificationService,
} from '../../../../../../../common';
import { TrailerHandlingCouplingPlanModel } from '../../../models/allocation-register-uli-details/trailer-handling/register-uli-trailer-handling.model';
import { TrailerHandlingListInitialState, TrailerHandlingListLoad } from './trailer-handling-list.action';
import { Observable, of } from 'rxjs';
import { SimpleSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { catchError, map, take } from 'rxjs/operators';
import { TrailerHandlingListService } from './trailer-handling-list.service';

export type TrailerHandlingListStateModel = ListServerPaginationStateModel<TrailerHandlingCouplingPlanModel>;

const initialState: TrailerHandlingListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State({
  name: 'trailerHandlingList',
  defaults: initialState,
})
@Injectable()
export class TrailerHandlingListState {
  constructor(
    private notificationService: NotificationService,
    private trailerHandlingListService: TrailerHandlingListService,
  ) {}

  @Selector()
  static getState(state: TrailerHandlingListStateModel): TrailerHandlingListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: TrailerHandlingListStateModel): boolean {
    return state.loaded;
  }

  @Action(TrailerHandlingListLoad)
  getCompartments(
    ctx: StateContext<TrailerHandlingListStateModel>,
    { payload }: TrailerHandlingListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.trailerHandlingListService.getCouplingPlanList(payload.hubId, payload.searchCriteria).pipe(
      take(1),
      map((list: TrailerHandlingCouplingPlanModel) => {
        ctx.patchState({ ...list, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TrailerHandlingListInitialState)
  setInitialState(ctx: StateContext<TrailerHandlingListStateModel>): void {
    ctx.setState(initialState);
  }
}
